exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".browse-vehicles[data-v-8ee60db6]{background:#fff;padding:15px 0}.browse-vehicles h2[data-v-8ee60db6]{margin-bottom:20px}.browse-vehicles .inventory-type-button-block[data-v-8ee60db6]{background-color:var(--primary-color);margin-bottom:1.4em;width:100%;font-weight:700;font-size:1.5em;color:#fff;border-radius:0;padding:10px 12px;-webkit-transition:all .3s ease;transition:all .3s ease}.browse-vehicles .inventory-type-button-block[data-v-8ee60db6]:active,.browse-vehicles .inventory-type-button-block[data-v-8ee60db6]:focus,.browse-vehicles .inventory-type-button-block[data-v-8ee60db6]:hover{opacity:.7;color:#fff}", ""]);

// exports
